"use strict";

var _slicedToArray = require("/home/circleci/project/web-front/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/slicedToArray");
var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault").default;
var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireWildcard(require("react"));
var _styledComponents = _interopRequireDefault(require("styled-components"));
var _tokens = _interopRequireDefault(require("../../../shared/tokens/tokens"));
var _components = require("../../../components");
var _Icon = require("../../media/icon/Icon");
var _jsxRuntime = require("react/jsx-runtime");
var PinnableSummaryCardsWrapper = _styledComponents.default.div.withConfig({
  displayName: "PinnableSummaryCards__PinnableSummaryCardsWrapper",
  componentId: "sc-83zjl3-0"
})(["display:flex;width:100%;", ";gap:", ";padding:", ";background-color:", ";margin-bottom:", ";"], function (_ref) {
  var topOffset = _ref.topOffset,
    isPinned = _ref.isPinned;
  return isPinned ? "\n\t\tposition: fixed;\n\t\ttop: ".concat(topOffset ? "".concat(topOffset, "px") : '0', ";\n\t\tleft: 0;\n\t\tborder-radius: 0 0 ").concat(_tokens.default.sky.sys.size.borderradius['3'], " ").concat(_tokens.default.sky.sys.size.borderradius['3'], ";\n\t") : "\n\t\tposition: relative;\n\t\tborder-radius: ".concat(_tokens.default.sky.sys.size.borderradius['3'], ";\n\t");
}, _tokens.default.sky.sys.spacing['300'], _tokens.default.sky.sys.spacing['300'], _tokens.default.sky.sys.color.background.primary['1'], _tokens.default.sky.sys.spacing['400']);
var SingleSummaryCard = _styledComponents.default.div.withConfig({
  displayName: "PinnableSummaryCards__SingleSummaryCard",
  componentId: "sc-83zjl3-1"
})(["width:100%;padding:", ";background:", ";border-radius:", ";"], _tokens.default.sky.sys.spacing['300'], _tokens.default.sky.sys.color.background.neutral['1'], _tokens.default.sky.sys.size.borderradius['3']);
var PinContainer = _styledComponents.default.div.withConfig({
  displayName: "PinnableSummaryCards__PinContainer",
  componentId: "sc-83zjl3-2"
})(["display:flex;align-items:center;"]);
var PinnableSummaryCards = function PinnableSummaryCards(_ref2) {
  var topOffset = _ref2.topOffset,
    summaryData = _ref2.summaryData;
  var _ref3 = (0, _react.useState)(false),
    _ref4 = _slicedToArray(_ref3, 2),
    isPinned = _ref4[0],
    setIsPinned = _ref4[1];
  return /*#__PURE__*/(0, _jsxRuntime.jsxs)(PinnableSummaryCardsWrapper, {
    isPinned: isPinned,
    topOffset: topOffset,
    children: [summaryData.map(function (element) {
      return /*#__PURE__*/(0, _jsxRuntime.jsxs)(SingleSummaryCard, {
        children: [/*#__PURE__*/(0, _jsxRuntime.jsx)("div", {
          children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_components.Text, {
            color: "auxiliary",
            size: 2,
            children: element.title
          })
        }), /*#__PURE__*/(0, _jsxRuntime.jsx)(_components.SubHeading, {
          size: 2,
          children: element.value
        })]
      });
    }), /*#__PURE__*/(0, _jsxRuntime.jsx)(PinContainer, {
      children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_Icon.Icon, {
        size: 'l',
        icon: isPinned ? 'unpin' : 'pin',
        onClick: function onClick() {
          return setIsPinned(!isPinned);
        }
      })
    })]
  });
};
var _default = exports.default = PinnableSummaryCards;